import goodDlg from "./goodDlg.js"; // 商品dlg

const supplyChainMan = {
  namespaced: true,
  modules: {
    goodDlg
  }
};

export default supplyChainMan;
